<template>
    <div v-if="mostrar">
        <div v-if="comandaItems" id="prinCom" style="text-align: center; font-size: 14px;">
			<div>
				<b-container>
					<div class="text-center" style="text-align: center; font-size: 14px;">
						<b-row>
							<b-col style="margin-top:10%">
								<template>
									TICKET SUMINISTRO
								</template>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<template>
									<b>{{comandaItems.nombreProducto.substring(0,54).toUpperCase()}}...</b> 
								</template>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<template>
									<div>
									<b>Total:</b> {{comandaItems.PrecioTotal}}
									<p>Precio Unitario: {{comandaItems.precioUnitario}}</p>
									<p>Cantidad: {{comandaItems.cantidadProducto}}</p>
								</div>
								</template>
							</b-col>
						</b-row>
					</div>
					<hr>
					<div>
						<template>
						<div class="text-left" style="font-size: 11px;">
							<div  style="display: inline-block; float: left; width: 50%;">
								<p><span>Conductor</span></p>
							</div>
							<div style="text-align:center;
										display: inline-block; 
										float: rigth; 
										width: 50%;">
								<div>
									<p><span>Documento</span></p>
								</div>                          
							</div>
							<div style="display: flex; display: inline-block; float: left; width: 50%; font-size: 14px">
								<p><span><b>{{comandaItems.conductor.apellidos}}</b></span></p>
							</div>
							<div style="text-align:center;
										display: inline-block; 
										float: rigth; 
										width: 50%;
										font-size: 14px">
								<div>
									<p><span><b>{{comandaItems.conductor.nroDocumento}}</b> </span></p>
								</div>                          
							</div>
						</div>
						</template>
						<br>
						<template>
						<div style="font-size: 11px;">
							<div  style="display: inline-block; 
										float: left; 
										width: 30%;">
								<p><span>Licencia</span></p>
							</div>
							<div style="text-align:center; 
										display: inline-block; 
										float: rigth; 
										width: 40%;">
								<div>
									<p><span>Cod.</span></p>
								</div>                          
							</div>
							<div style="text-align:center;
										display: inline-block; 
										float: rigth; 
										width: 30%;">
								<div>
									<p><span>Edad</span></p>
								</div>                          
							</div>
							<div style="display: inline-block; 
										float: left;
										width: 30%;
										font-size: 14px">
								<p><span><b>{{comandaItems.conductor.catLicencia}}</b></span></p>
							</div>
							<div style="display: inline-block; 
										text-align:center;
										float: rigth; 
										width: 40%;
										font-size: 14px">
								<div>
									<p><span><b>{{comandaItems.conductor.codigo}}</b> </span></p>
								</div>                          
							</div>
							<div style="text-align:center;
										display: inline-block; float: rigth; 
										width: 30%;
										font-size: 14px">
								<div>
									<p><span><b>{{edad}}</b> </span></p>
								</div>                          
							</div>
							<hr>
						</div>
						</template>
						<!-- vehiculo -->
						<template>
						<div class="text-left" style="font-size: 11px;">
							<div  style="display: inline-block; float: left; width: 50%;">
								<p><span>Placa-Vehículo</span></p>
							</div>
							<div style="text-align:center;
										display: inline-block; 
										float: rigth; 
										width: 50%;">
								<div>
									<p><span>Tipo-Vehículo</span></p>
								</div>                          
							</div>
							<div style="display: flex; display: inline-block; float: left; width: 50%; font-size: 14px">
								<p><span><b>{{comandaItems.vehiculo.placa}}</b></span></p>
							</div>
							<div style="text-align:center;
										display: inline-block; 
										float: rigth; 
										width: 50%;
										font-size: 14px">
								<div>
									<p><span><b>{{comandaItems.vehiculo.tipoVehiculo}}</b> </span></p>
								</div>                          
							</div>
						</div>
						</template>
						<br>
						<template>
						<div style="font-size: 11px;">
							<div  style="display: inline-block; 
										float: left; 
										width: 30%;">
								<p><span>Peso Bruto</span></p>
							</div>
							<div style="text-align:center; 
										display: inline-block; 
										float: rigth; 
										width: 40%;">
								<div>
									<p><span>Carga util</span></p>
								</div>                          
							</div>
							<div style="text-align:center;
										display: inline-block; 
										float: rigth; 
										width: 30%;">
								<div>
									<p><span>Max.Pasajeros</span></p>
								</div>                          
							</div>
							<div style="display: inline-block; 
										float: left;
										width: 30%;
										font-size: 14px">
								<p><span><b>{{comandaItems.vehiculo.pesoBruto}}</b></span></p>
							</div>
							<div style="display: inline-block; 
										text-align:center;
										float: rigth; 
										width: 40%;
										font-size: 14px">
								<div>
									<p><span><b>{{comandaItems.vehiculo.cargaUtil}}</b> </span></p>
								</div>                          
							</div>
							<div style="text-align:center;
										display: inline-block; float: rigth; 
										width: 30%;
										font-size: 14px">
								<div>
									<p><span><b>{{comandaItems.vehiculo.maximoTripulacion}}</b> </span></p>
								</div>                          
							</div>
						</div>
						</template>
					</div>	
					</b-container>
				 </div>
            </div>
        </div>
</template>
<script>
export default {
    name:'PrintTicketSuministro',
    props:['dataitem','printTicket'],
    data() {
        return {
            comandaItems:{},   
            mostrar: false,
            edad:''
        }
    },
     watch: {
        printTicket: function () {
            if(this.printTicket == true){
                var printContents = document.getElementById("prinCom").innerHTML
                var myWindow = window.open("", "MsgWindow", "width=400,height=800")
                myWindow.document.body.style.fontSize='10px'
                myWindow.document.body.style.textAlign='center'
                myWindow.document.write(printContents)
                myWindow.print(printContents)
                myWindow.close()
            }
        }
    },
    mounted(){
      this.mostrarData()  
    },
    methods:{
        mostrarData(){
            this.comandaItems = this.dataitem;
            if(this.comandaItems !=''){
                this.mostrar = true
            }
            var hoy = new Date();
            var cumpleanos = new Date(this.comandaItems.conductor.fechaNacimiento);
            var edad = hoy.getFullYear() - cumpleanos.getFullYear();
            var m = hoy.getMonth() - cumpleanos.getMonth();
            if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                edad--;
            }
            this.edad = edad;
        }
    }
}
</script>
<style media="all" lang="scss" scoped>

@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");

$container: #e0e2e8;
$topbg: #ffcc05;
$bottombg: #fff;
$font: "Open Sans", sans-serif;
$grey: #6c6c6c;

body,
p,
h1 {
	margin: 0;
	padding: 0;
	font-family: $font;
}

.container {
	background: $container;
	position: relative;
	width: 100%;
	height: 47vh; //contenedor gris
    border-radius: 22px;
}

</style>